import { AreaChart, Area, ResponsiveContainer, YAxis } from "recharts";

export function Sparkline({ data = [], up = true, height = 40 }) {
  if (!data.length) return <div style={{ height }} />;
  const chartData = data.map((price, i) => ({ i, price }));
  const color = up ? "hsl(var(--bullish))" : "hsl(var(--bearish))";
  const id = `spark-${Math.random().toString(36).slice(2)}`;
  const min = Math.min(...data);
  const max = Math.max(...data);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.25} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[min, max]} />
        <Area
          type="monotone"
          dataKey="price"
          stroke={color}
          strokeWidth={1.5}
          fill={`url(#${id})`}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
